import {ToggleOn, ToggleOff} from 'react-bootstrap-icons'

interface PlayerUISwitchProps {
    id: string
    label: string
    description?: string
    checked: boolean
    onChange: (checked: boolean) => void
    disabled?: boolean
}

const PlayerUISwitch: React.FC<PlayerUISwitchProps> = ({
    id,
    label,
    description,
    checked,
    onChange,
    disabled = false
}) => {
    const handleClick = () => {
        if (!disabled) {
            onChange(!checked)
        }
    }

    return (
        <div
            id={id}
            className={`d-flex align-items-start ${disabled ? 'opacity-50' : ''}`}
            onClick={handleClick}
            style={{cursor: disabled ? 'not-allowed' : 'pointer'}}
            role="switch"
            aria-checked={checked}
            aria-disabled={disabled}
            tabIndex={0}
            onKeyDown={(e) => {
                if ((e.key === 'Enter' || e.key === ' ') && !disabled) {
                    e.preventDefault()
                    onChange(!checked)
                }
            }}
        >
            {checked ? (
                <ToggleOn size={28} className="text-success me-3 flex-shrink-0" />
            ) : (
                <ToggleOff size={28} className="text-muted me-3 flex-shrink-0" />
            )}
            <div>
                <div className="fw-medium">{label}</div>
                {description && <div className="text-muted small">{description}</div>}
            </div>
        </div>
    )
}

export default PlayerUISwitch
